import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { C3StaticDataEdit } from "./edit";
import { C3StaticDataNew } from "./new";
import { C3StaticDataTable } from "./table";

export default function C3StaticData() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Actifs financiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<C3StaticDataEdit />} />
      <Route index element={<C3StaticDataTable />} />
      <Route path="/new" element={<C3StaticDataNew />} />
    </Routes>
  );
}
